<template>
    <div>
        <el-row class="u-mt-10 u-mb-20" :gutter="10">
            <el-col :xs="24" :sm="6" :md="4">
                <el-input v-model="filtroAno" placeholder="Ano letivo" v-mask="'####'" @keyup.native.enter="load"></el-input>
            </el-col>
            <el-col :xs="24" :sm="4" :md="3">
                <el-button @click="load" type="primary" plain>FILTRAR</el-button>
            </el-col>
            <el-col :xs="24" :sm="14" :md="17" class="u-text-right">
                <router-link to="/admin/tabulacao/periodos/form" class="btn-new-register">
                    <el-button type="primary">NOVO PERÍODO</el-button>
                </router-link>
            </el-col>
        </el-row>

        <div class="container-table">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th style="width: 70px;">Nº</th>
                        <th>Descrição</th>
                        <th style="width: 90px;">Ano</th>
                        <th style="width: 80px;">Ordem</th>
                        <th class="hidden-mobile" style="width: 110px;">Início</th>
                        <th class="hidden-mobile" style="width: 110px;">Fim</th>
                        <th class="hidden-mobile" style="width: 110px;">Status</th>
                        <th style="width: 140px;" class="u-text-center">Ação</th>
                    </tr>
                </thead>
                <tbody v-if="statusList">
                    <tr v-for="item in items" :key="item.id">
                        <td>{{ item.id }}</td>
                        <td>{{ item.descricao }}</td>
                        <td>{{ item.ano_letivo }}</td>
                        <td>{{ item.ordem }}º</td>
                        <td class="hidden-mobile">{{ formatDate(item.data_inicio) }}</td>
                        <td class="hidden-mobile">{{ formatDate(item.data_fim) }}</td>
                        <td class="hidden-mobile">
                            <span v-if="item.status == 1" style="color: #67c23a;">Aberto</span>
                            <span v-else style="color: #909399;">Encerrado</span>
                        </td>
                        <td class="u-text-center acao">
                            <router-link :to="'/admin/tabulacao/periodos/form/' + item.id" class="link-icon u-mr-10" style="color: rgba(0, 0, 0, 0.87) !important;">
                                <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                            </router-link>
                            <el-button @click="excluir(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                        </td>
                    </tr>
                    <tr v-if="!items.length">
                        <td colspan="8" class="u-text-center" style="padding: 20px;">Nenhum período diagnóstico cadastrado.</td>
                    </tr>
                </tbody>
            </table>

            <div v-if="!statusList" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        statusList: false,
        filtroAno: '',
        items: []
    }),
    mounted () { this.load() },
    methods: {
        formatDate (d) {
            if (!d) return '—'
            return this.$moment(d).format('DD/MM/YYYY')
        },
        load () {
            this.statusList = false
            this.items = []
            const url = this.filtroAno
                ? `${this.$store.state.config.baseUrlApi}/api/periodo-diagnostico/getAll/${this.filtroAno}`
                : `${this.$store.state.config.baseUrlApi}/api/periodo-diagnostico/getAll`
            this.$axios.get(url, this.$store.getters.getHeaderAuth)
                .then(response => { this.items = response.data || []; this.statusList = true })
                .catch((error) => { this.$store.commit('throwException', error) })
        },
        excluir (id) {
            this.$msgbox.confirm('Tem certeza que deseja excluir este período?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
                .then(() => {
                    window.eventBus.$emit('loading', true)
                    this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/periodo-diagnostico/delete/` + id, this.$store.getters.getHeaderAuth)
                        .then(response => {
                            window.eventBus.$emit('loading', false)
                            if (response.data && response.data.erro) {
                                const t = typeof response.data.erro === 'string' ? response.data.erro : response.data.erro.text
                                window.eventBus.$emit('alert', { msg: t, type: 'warning' })
                                return
                            }
                            window.eventBus.$emit('alert', { msg: 'Período excluído com sucesso.', type: 'success' })
                            this.load()
                        }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
                }).catch(() => {})
        }
    }
}
</script>
